module.exports = __webpack_public_path__ + "img/inactive.7fb1544f.svg";